import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { CancelManager } from 'src/app/data/manager/order/cancel/cancel.manager';
import { countryConfig } from 'src/country-config/country-config';
import { LocalStorageManager } from '../../data/manager/local-storage/local-storage.manager';

const domain = !countryConfig.getService
  ? `https://monitor30-dot-stunning-base-164402.uc.r.appspot.com/backend/flexible/v2/monitor`
  : 'https://monitor30-dot-oracle-services-vzla.uc.r.appspot.com/backend/flexible/v2/monitor'

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
};

@Injectable({providedIn: 'root'})
export class CancelOrderModalVm {
  hasChange: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private cancelManager:CancelManager,
  ) { }

  getUser() {
    return this.cancelManager.getUser();
  }

  sessionActive() {
    return this.cancelManager.getUser();
  }

  setCancelOrder(data: any){
    return this.cancelManager.setCancelOrder(data);
  }

  getListOrderCancellationReasonCustomer() {
    return this.cancelManager.getListOrderCancellationReasonCustomer();
  }

  setCancelOrderEvent(data: any) {
    this.cancelManager.setCancelOrderEvent(data);
  }
}
